import TickerList from './TickerList';

export default TickerList;
